/**
 * ローカルストレージの運用方針
 * ・キー名には、バージョンとハッシュ化したユーザーIDを先頭に付与する
 *   {バージョン}_{暗号化したユーザーID}_{キー名}
 */
const STORAGE_VERSION = 'v2';

/**
 * userId を SHA-256 でハッシュ化
 */
async function hashUserId(userId: string | number): Promise<string> {
    // エンコード
    const encoder = new TextEncoder();
    const data = encoder.encode(String(userId));
    // ハッシュ化
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // 16進数に変換
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

/**
 * ローカルストレージに保存
 */
export async function setLocalStorage(
    userId: string | number,
    key: string,
    value: string,
): Promise<void> {
    const hashed = await hashUserId(userId);
    localStorage.setItem(`${STORAGE_VERSION}_${hashed}_${key}`, value);
}

/**
 * ローカルストレージから取得
 */
export async function getLocalStorage(
    userId: string | number,
    key: string,
): Promise<string | null> {
    const hashed = await hashUserId(userId);
    return localStorage.getItem(`${STORAGE_VERSION}_${hashed}_${key}`);
}

/**
 * ローカルストレージから削除
 */
export async function removeLocalStorage(
    userId: string | number,
    key: string,
): Promise<void> {
    const hashed = await hashUserId(userId);
    localStorage.removeItem(`${STORAGE_VERSION}_${hashed}_${key}`);
}
